import { render, staticRenderFns } from "./PianoTerapeuticoUtente.vue?vue&type=template&id=6a056032&"
import script from "./PianoTerapeuticoUtente.vue?vue&type=script&lang=js&"
export * from "./PianoTerapeuticoUtente.vue?vue&type=script&lang=js&"
import style0 from "./PianoTerapeuticoUtente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports